import { HomeOutlined } from "@ant-design/icons";

const HomeHeader = () => {
  return (
    <h2 className="header-section-title">
      <HomeOutlined rev={undefined} />
      <span style={{ marginLeft: "5px" }}>Home</span>
    </h2>
  );
};

export default HomeHeader;
